import React, { useEffect, useState, useContext } from 'react';
import ChannelForm from './channel-form';
import { getQuery } from '@/common/utils';
import apis from '../../apis';
import { message } from 'antd';
import useTabSetting from '../../useTabSetting';

const AddChannel = (props) => {
  useTabSetting(false);
  const [data, setData] = useState({});
  const url = window.location.href;
  const channelId = getQuery('channelId', url);
  useEffect(() => {
    if (!channelId) return;
    apis.channelMicroGetChannel({ channelId }).then((res) => {
      const { ret, data, msg } = res;
      if (ret === '0') {
        setData(data);
      } else {
        message.error(msg);
      }
    });
  }, [channelId]);

  return <ChannelForm initialValue={data} />;
};
export default AddChannel;
